const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var ApplePay24 = function ApplePay24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.87 5a2.99 2.99 0 0 0-1.94.983 2.71 2.71 0 0 0-.678 1.982 2.253 2.253 0 0 0 1.957-.847c.49-.592.728-1.353.66-2.118zm.949 6.912a2.855 2.855 0 0 1 1.389-2.457A2.93 2.93 0 0 0 9.87 8.16c-.653-.041-1.252.193-1.733.382-.306.119-.563.22-.757.22-.217 0-.49-.107-.798-.227-.403-.158-.87-.34-1.354-.34a3.16 3.16 0 0 0-2.685 1.634c-1.135 1.99-.314 4.93.847 6.54.542.787 1.203 1.694 2.058 1.643.398-.024.672-.14.948-.26.318-.136.64-.274 1.161-.274.49 0 .807.134 1.114.264.305.129.599.253 1.038.236.88-.034 1.448-.788 1.99-1.61a6.414 6.414 0 0 0 .848-1.83 2.855 2.855 0 0 1-1.728-2.625zm8.258 1.864h-2.54l.033 4.074h-1.864V5.915h4.448A3.753 3.753 0 0 1 23.1 9.828a3.795 3.795 0 0 1-4.024 3.948zm-.39-6.277h-2.15l-.035 4.735h2.186a2.236 2.236 0 0 0 2.54-2.372c0-1.516-.93-2.363-2.54-2.363zM34.724 18.45a1.448 1.448 0 0 1-1.542 1.237 3.184 3.184 0 0 1-.567 0v1.406c.152 0 .593 0 .72.068 1.804 0 2.66-.66 3.388-2.778L40 9.235h-1.898l-2.219 7.073-2.228-7.073h-1.93l3.159 8.717-.161.5zM23.575 15.42c0-1.516 1.17-2.457 3.253-2.584l2.364-.127v-.669c0-.974-.627-1.542-1.695-1.542a1.694 1.694 0 0 0-1.846 1.28h-1.694c.067-1.601 1.44-2.77 3.557-2.77 2.118 0 3.473 1.11 3.473 2.88v5.997h-1.694V16.46a3.092 3.092 0 0 1-2.744 1.584c-1.77 0-2.974-1.11-2.974-2.626zm5.457.018c.12-.252.189-.526.202-.806l.025-.694-2.151.127c-1.102.059-1.694.542-1.694 1.296 0 .753.626 1.262 1.575 1.262a2.092 2.092 0 0 0 2.043-1.185z",
      fill: "#000",
    })
  );
};
ApplePay24.defaultProps = {
  width: "42",
  height: "24",
  viewBox: "0 0 42 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var ApplePay32 = function ApplePay32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.66 8.8c.28-.35.48-.82.42-1.3a1.81 1.81 0 0 0-1.63 1.88c.46.04.92-.23 1.21-.58Zm.42.67c-.67-.04-1.24.38-1.56.38-.32 0-.81-.36-1.34-.35-.69 0-1.33.4-1.68 1.02-.72 1.24-.19 3.08.51 4.09.34.5.75 1.05 1.29 1.03.51-.02.71-.33 1.33-.33.62 0 .8.33 1.34.32.56-.01.9-.5 1.25-1 .39-.57.55-1.12.56-1.15-.01-.01-1.08-.42-1.1-1.65 0-1.03.85-1.52.89-1.55a1.92 1.92 0 0 0-1.5-.81Zm5.83-1.4c1.46 0 2.47 1 2.47 2.47 0 1.46-1.03 2.47-2.5 2.47h-1.62v2.57H12.1v-7.5h2.81Zm-1.65 3.96h1.34c1.01 0 1.6-.54 1.6-1.49 0-.94-.59-1.49-1.6-1.49h-1.34v2.98Zm4.43 1.99c0-.96.73-1.54 2.03-1.62l1.5-.08v-.43c0-.6-.41-.97-1.1-.97-.65 0-1.06.31-1.15.8H17.9c.07-.99.9-1.71 2.26-1.71 1.33 0 2.17.7 2.17 1.8v3.77h-1.07v-.9h-.03c-.31.6-1 .99-1.72.99-1.08 0-1.82-.67-1.82-1.65Zm3.53-.5v-.42l-1.35.08c-.67.05-1.05.34-1.05.8 0 .49.4.8 1 .8.78 0 1.4-.54 1.4-1.25Zm2.13 4.07v-.91c.08.02.27.02.36.02.52 0 .8-.22.98-.78l.1-.34-1.98-5.47h1.22l1.38 4.45h.02l1.38-4.45H28l-2.05 5.75c-.47 1.33-1 1.75-2.14 1.75-.1 0-.38 0-.46-.02Z",
      fill: "#000",
    })
  );
};
ApplePay32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: ApplePay24,
  32: ApplePay32,
};
export function ApplePay(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'ApplePay' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
